// src/pages/storePages/manageStore/ProjectPicker.js
import { useEffect, useRef, useState } from "react";
import "../../../static/storecss/manageStore/ProjectPicker.css";

export default function ProjectPicker({ projects, value, onChange }) {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const selected = projects.find((p) => String(p.id) === String(value));

  const filtered = query.trim()
    ? projects.filter((p) =>
        p.title.toLowerCase().includes(query.toLowerCase())
      )
    : projects;

  useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div className="picker" ref={containerRef}>
      <button
        type="button"
        className="picker-toggle"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="picker-toggle-label">
          {selected ? selected.title : "— Select a project —"}
        </span>
        <i className="fa-solid fa-chevron-down" />
      </button>

      {open && (
        <div className="picker-menu">
          <div className="picker-search">
            <i className="fa-solid fa-magnifying-glass" />
            <input
              type="text"
              placeholder="Search projects…"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              autoFocus
            />
          </div>

          <ul className="picker-list">
            <li>
              <button
                type="button"
                className="picker-item picker-clear"
                onClick={() => {
                  onChange("");
                  setQuery("");
                  setOpen(false);
                }}
              >
                — None —
              </button>
            </li>

            {filtered.length === 0 ? (
              <li className="picker-empty">No matches.</li>
            ) : (
              filtered.map((p) => (
                <li key={p.id}>
                  <button
                    type="button"
                    className={`picker-item ${
                      String(p.id) === String(value) ? "active" : ""
                    }`}
                    onClick={() => {
                      onChange(String(p.id));
                      setQuery("");
                      setOpen(false);
                    }}
                  >
                    {p.title}
                  </button>
                </li>
              ))
            )}
          </ul>
        </div>
      )}
    </div>
  );
}